import { Form, Input, Button, Row, Col, Modal, LocaleProvider } from 'ant-design-vue'
// import FlightCitySelector from '@/components/flightcityselector'
// import Calendar from '@/components/calendar'
import { FlightCitySelector, Calendar } from 'ace-ui-eking'
// import { FlightCitySelector } from 'ace-ui-eking'
import Passenger from '@/components/input-passenger'
import '@/components/l8-icon'
import FlightSearchMenu from './FlightSearchMenu.vue'
import './index.less'

/* istanbul ignore next */
FlightSearchMenu.install = function (Vue) {
  Vue.use(LocaleProvider)
  Vue.use(Form)
  Vue.use(Button)
  Vue.use(Input)
  Vue.use(Row)
  Vue.use(Col)
  Vue.use(Modal)
  Vue.use(Passenger)
  Vue.use(Calendar)
  Vue.use(FlightCitySelector)

  Vue.component(FlightSearchMenu.name, FlightSearchMenu)
}

export default FlightSearchMenu
